import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { countries, devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the FilterPromotionalCodesView.
 * @extends JetView
 */
export default class FilterPromotionalCodesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const lang = this.app.getService('locale').getLang(); // Get current language
        const left = {
            margin: 5,
            id: 'a9',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a9',
                    cols: [
                        {
                            view: 'text', // Text input for ID
                            minWidth: 200,
                            name: 'Id',
                            type: 'number',
                            label: _('ID'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('ID'), // Localized placeholder
                        },
                        {
                            view: 'text', // Text input for PlayerExternalId
                            minWidth: 200,
                            name: 'PlayerExternalId',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // Localized label with icon
                            hidden: !devConfig.getPermAction(
                                'filterByUser',
                                'Add', // Permission check for visibility
                            ),
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'), // Localized placeholder
                        },
                        {
                            view: 'text', // Text input for CasinoId
                            minWidth: 200,
                            name: 'CasinoId',
                            type: 'number',
                            label: _('ID Casino'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('ID Casino'), // Localized placeholder
                        },
                        {
                            view: 'richselect', // Dropdown for ResultTypeId
                            name: 'ResultTypeId',
                            label: _('Estado'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                            value: '4', // Default value
                            options: [
                                { id: '4', value: _('Comprado') }, // Localized option
                                { id: '5', value: _('Entregado') }, // Localized option
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a9',
                    cols: [
                        {
                            view: 'text', // Text input for Datepicker
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                        },
                        {
                            view: 'datepicker', // Datepicker for Date
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                            value: moment().format('YYYY-MM-DD'), // Default value
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Limit to today's date
                                },
                            },
                        },
                        {
                            view: 'text', // Text input for DateM
                            name: 'DateM',
                            id: 'DateM',
                            css: 'reportrange2',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha Modificó'), // Localized label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                        },
                        {
                            view: 'datepicker', // Datepicker for DateM2
                            name: 'DateM2',
                            id: 'DateM2',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha Modificó'), // Localized label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                            value: moment().format('YYYY-MM-DD'), // Default value
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Limit to today's date
                                },
                            },
                        },
                        {
                            view: 'richselect', // Dropdown for Country selection
                            minWidth: 200,
                            name: 'Country',
                            id: 'CountrySelect',
                            label: "<span class='icon-language'></span>" + _('País'), // Localized label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Country flag and name
                                        );
                                    },
                                    data: countries, // Country data
                                },
                            },
                            hidden:
                                devConfig.getCountryReport() ||
                                !devConfig.getPermAction(
                                    'filterByCountry',
                                    'Add', // Permission check for visibility
                                ),
                            css: 'prm-filterByCountry' || true,
                        },
                        {
                            view: 'text', // Text input for IdBonus
                            minWidth: 200,
                            name: 'IdBonus',
                            type: 'number',
                            label: _('Id Regalo'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Id Regalo'), // Localized placeholder
                        },
                        {
                            view: 'richselect', // Dropdown for TypeAward selection
                            name: 'TypeAward',
                            id: 'TypeAward',
                            label: _('Tipo'), // Localized label
                            labelPosition: 'top',
                            value: '1', // Default value
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                            options: [
                                { id: '1', value: _('Online') }, // Localized option
                                { id: '0', value: _('Físico') }, // Localized option
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a9',
                    cols: [
                        {
                            view: 'richselect',                                              // Component type: enriched dropdown selector
                            name: 'LoyaltyLevel',                                            // Field name, used to identify its value
                            minWidth: 200,                                                   // Minimum width of the component in pixels
                            label: "<span class='icon-state'></span>" + _('Nivel del jugador'), // Label displayed above the selector (with icon and internationalization)
                            labelPosition: 'top',                                            // Label position: above the selector
                            placeholder: _('Click para seleccionar '),                       // Text shown when no option is selected
                            value: '',                                                       // Initial empty value (no selection)
                            options: [
                                { id: '1', value: _('1') },                                  // Option with id 1 and displayed translated value "1"
                                { id: '2', value: _('2') },
                                { id: '3', value: _('3') },
                                { id: '4', value: _('4') },
                                { id: '5', value: _('5') },
                                { id: '6', value: _('6') },
                                { id: '7', value: _('7') },
                                { id: '8', value: _('8') },
                                { id: '9', value: _('9') },
                                { id: '10', value: _('10') },
                            ],
                        },
                        {
                            view: 'richselect',                                              // Component type: enriched dropdown selector
                            name: 'RequiredLevelGift',                                       // Field name, used to identify its value
                            minWidth: 200,                                                   // Minimum width of the component in pixels
                            label: "<span class='icon-state'></span>" + _('Nivel requerido del regalo'), // Selector label with icon and internationalization
                            labelPosition: 'top',                                            // Label position: above the selector
                            placeholder: _('Click para seleccionar '),                       // Text shown when no option is selected
                            value: '',                                                       // Initial empty value (no selection)
                            options: [
                                { id: '1', value: _('1') },                                  // Option with id 1 and displayed translated value "1"
                                { id: '2', value: _('2') },
                                { id: '3', value: _('3') },
                                { id: '4', value: _('4') },
                                { id: '5', value: _('5') },
                                { id: '6', value: _('6') },
                                { id: '7', value: _('7') },
                                { id: '8', value: _('8') },
                                { id: '9', value: _('9') },
                                { id: '10', value: _('10') },
                            ],
                        },
                        { gravity: 1, minWidth: 200 },
                        { gravity: 1, minWidth: 200 },
                        { gravity: 1, minWidth: 200 },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a9',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for WayToPay selection
                            name: 'WayToPay',
                            id: 'WayToPay',
                            hidden: true, // Initially hidden
                            label: _('Forma de Pago'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                            options: [
                                { id: '1', value: _('Local Propio') }, // Localized option
                                { id: '2', value: _('Red Aliada') }, // Localized option
                                { id: '3', value: _('Domicilio') }, // Localized option
                            ],
                        },
                        { gravity: 3 }, // Flexible space
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Flexible space
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'), // Localized label
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form values
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'), // Localized label
                            hotkey: 'enter', // Shortcut key
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            id: 'consultDesk',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove Date if typeDate is not 2
                                    delete filterdata['DateM2']; // Remove DateM2 if typeDate is not 2
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                                        delete filterdata['DateM']; // Remove DateM if typeDate is 2
                                    }
                                }
                                this.app.callEvent('report:filter', [
                                    filterdata, // Trigger filter event with data
                                ]);
                                $$('b5').collapse(); // Collapse the filter section
                            },
                        },
                    ],
                },
            ],
        };
        const buttons2 = {
            rows: [
                {
                    padding: 10,
                    cols: [
                        {
                            view: 'button', // Clear button for second form
                            value: _('Limpiar'), // Localized label
                            click: () => {
                                $$('myForm2').clear(); // Clear form values
                            },
                        },
                        {
                            view: 'button', // Consult button for second form
                            value: _('Consultar'), // Localized label
                            hotkey: 'enter', // Shortcut key
                            type: 'form',
                            click: () => {
                                const filterdata = $$('myForm2').getValues(); // Get form values
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove Date if typeDate is not 2
                                    delete filterdata['DateM2']; // Remove DateM2 if typeDate is not 2
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                                        delete filterdata['DateM']; // Remove DateM if typeDate is 2
                                    }
                                }
                                this.app.callEvent('report:filter', [
                                    filterdata, // Trigger filter event with data
                                ]);
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filter sections
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Localized header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section with filters and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for filters
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Upper section with filters
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Localized label
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form', // Main form view
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 }, // Placeholder for small screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal after rendering
        });
        $$('DateM').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal after rendering
        });
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date if typeDate is not 2
                $$('Datepicker').show(); // Show Datepicker
                $$('DateM2').hide(); // Hide DateM2 if typeDate is not 2
                $$('DateM').show(); // Show DateM
            } else {
                if (true) {
                    $$('Date').show(); // Show Date if typeDate is 2
                    $$('Datepicker').hide(); // Hide Datepicker
                    $$('DateM2').show(); // Show DateM2
                    $$('DateM').hide(); // Hide DateM if typeDate is 2
                }
            }
            $$('TypeAward').attachEvent('onChange', function (newv, oldv) {
                if ($$('TypeAward').getValue() == '1') {
                    $$('WayToPay').hide(); // Hide WayToPay if TypeAward is 'Online'
                } else {
                    $$('WayToPay').show(); // Show WayToPay otherwise
                }
            });
        });
    }
}

// FILE DOCUMENTED
